

const click            = require('../../js/click')
const dbRequest        = require ('../../js-network/db-request')
const loginDB          = require('./login-db')
const loginHandler     = require('./login-handler')
const snack            = require('../snack/snack')
const loading          = require ('../loading/loading')
const fullcontHandler  = require('../fullcont/fullcont-handler')

const validator          = require('../textfield/validator.min')
const textfieldValidator = require('../textfield/textfield-validator')

/****************ELEMENTS*****************/
var htmlLg          = {}
var HTMLwasSelected = false

function HTMLselect(){ 
   
    loginHandler.HTMLselect(htmlLg)
    HTMLwasSelected     = true
}
/****************ELEMENTS*****************/


export function start(detail, detailPrev){  // console.log('login start >', detail)
  
   if(!HTMLwasSelected) {HTMLselect()}
 
        switch (detail.act){
            case 'show':          show(detail, detailPrev);  break; 
            case 'hide':          loginHandler.hide(htmlLg); break; 
            // case 'logMeOut':      loginDB.logMeOut(detail);  break;
            case 'logMeOut':      logMeOut(detail);          break; 
            case 'verify':        verify();                  break; 
            case 'verifyFromKey': verifyFromKey(detail);     break; 
            case 'resetPassword': resetPassword(detail);     break; 

        }
}/**/


function logMeOut(detail){ 

        const x = fullcontHandler.closeBeforeExit()
        //console.log('log me out', 'xxxxxxxxxxxxxxxxx')

        if( x === true ){  //console.log('DONT EXIT ')
            return
        }

        loginDB.logMeOut(detail)
       // console.log('GO TO EXIT')
}

function show(detail, detailPrev){ //console.log('login show xx>', detail, detailPrev)
  
  //in case, is open
  loading.hide()

  //show the element/scrim
  htmlLg.login.classList.add('login-show') 
  htmlLg.scrim.classList.add('scrim-show')

  //load error, msg
  loginHandler.showMsg(detail, htmlLg)


  //if the detailPrev.dest is fromLogin, is becasue was called from login, 
  //don't overwrite the original db-request detail
  //if(detailPrev.dest != undefined ){  
  
  if(detailPrev.dest != 'fromLogin' ){  
     localStorage.setItem('detailPrev', JSON.stringify(detailPrev))
  }

  //don't focus on phone, could be uncomfortable
  if( window.screen.width > 1200 ){
      htmlLg.username.querySelector('input').focus()
  }

}/*show*/


export async function validateEmail(htmlLg) {

    let usernameInput = htmlLg.username.querySelector('input');
    let username = usernameInput.value.trim();

        // Crear un nuevo objeto detailInput, para que siempre tenga el evento correcto
    let detailInput = {};
    detailInput.ev = {};
    detailInput.ev.target = usernameInput;


    if (validator.isEmail(username)) {
        textfieldValidator.completed(detailInput.ev);
        return true;

    } else {
        textfieldValidator.incomplete(detailInput.ev, 'Invalid Email');
        return false;
    }

}


function verify(){ //console.log('login verify >')
  
  if( loginHandler.inputsErrors(htmlLg) ){ return }

    // if (!validateEmail(htmlLg)) {
    //     return
    // }
      
  verifyDB()
  .then((result) =>{ 

      
        loginHandler.hide(htmlLg)

        //send to click the previous details, before the auth error
        click.start( JSON.parse( localStorage.getItem('detailPrev') ) )

        //clean the label/input
        loginHandler.clean(htmlLg)

        snack.start({ act:'show', id:'loginOk' })

        return

  }).catch((error) =>{  //console.log('error loginx', error)

        snack.start({ act:'show', id:'loginError' })
    }) 

}/*verify*/



async function verifyDB(){ 

   const detail = loginHandler.getInf(htmlLg)

   const result = await dbRequest.start(detail, 'server/php/auth/tryAuth.php') //do the insert
 
   if(result.status != "ok"){ throw ( result ) }

   return result
}


//Login > Enter Press > move to password > move to submitted
function verifyFromKey(detail){ //console.log('login verify >')

    // if(!validateEmail(htmlLg)) { return }


    const inputId = detail.ev.target.parentElement.id
    
    if(detail.ev.key === 'Enter'){

       if( inputId === 'login_form_username'){
           htmlLg.password.querySelector('input').focus()
       }
       
       if( inputId === 'login_form_password'){
          verify()
       }

    }/**/
}/*show*/


function resetPassword(detail) {
    window.location.href = 'password-reset/password-reset.html';

}


